import type { PageType } from '@maestro/core'

import {
  GA_PAGE_MAPPING,
  type GApageType,
  type GaPageTypeMapping,
  type GaPageViewParams,
} from '@maestro/google-analytics/types'

export const resolveGaPageViewParams = (
  pageType: PageType | string,
  pageTypeMapping?: GaPageTypeMapping
): GaPageViewParams | { page_type: undefined } => {
  const value = { ...GA_PAGE_MAPPING, ...pageTypeMapping }[pageType]
  if (value === undefined) {
    return { page_type: value }
  }
  return typeof value === 'string' ? { page_type: value } : value
}

export const resolveGaPageType = (
  pageType: PageType | string,
  pageTypeMapping?: GaPageTypeMapping
): GApageType | string | undefined =>
  resolveGaPageViewParams(pageType, pageTypeMapping).page_type
